import { atom } from 'recoil'

import { UPLOADER_VARIANT_DEFAULT } from 'mailup-web-components'

export const uploaderState = atom({
  key: 'overviewMessageUploaderState',
  default: {
    variant: UPLOADER_VARIANT_DEFAULT,
    hintDanger: '',
    uploading: {}
  }
})
